import { render } from "./AccessManagementView.vue?vue&type=template&id=3b98b00b"
import script from "./js/accessManagementView.js?vue&type=script&lang=js&external"
export * from "./js/accessManagementView.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__